import Registration from './registration/Registration'

export default function RegistrationPage() {
  return <Registration />
}
